/** @jsx jsx */
import { jsx } from '@theme-ui/core';
var styles = {
  modalBody: {
    padding: 3
  }
};
var ModalBody = function ModalBody(_ref) {
  var children = _ref.children;
  return jsx("div", {
    sx: styles.modalBody
  }, children);
};
export { ModalBody };